// // core/interceptors/auth.interceptor.ts
// import { HttpInterceptorFn } from '@angular/common/http';
// import { inject } from '@angular/core';
// import { Router } from '@angular/router';
// import { AuthService } from '../services/auth/auth.service';
// import { ToastrService } from 'ngx-toastr';
// import { HttpErrorResponse } from '@angular/common/http';
// import { tap } from 'rxjs/operators';

// export const authInterceptor: HttpInterceptorFn = (req, next) => {
//   const router = inject(Router);
//   const authService = inject(AuthService);
//   const toastr = inject(ToastrService);

//   return next(req).pipe(
//     tap({
//       error: (err) => {
//         if (err instanceof HttpErrorResponse && err.status === 401) {
//           const isLoginOrRegister =
//             req.url.includes('/LogInEmployer') ||
//             req.url.includes('/RegisterCompany') ||
//             req.url.includes('/VerifyLoginEmployerOTP');

//           if (!isLoginOrRegister) {
//             authService.logout();
//             toastr.warning('Your session has expired. Please log in again.', 'Session Expired');
//             router.navigate(['/login']);
//           }
//         }
//       }
//     })
//   );
// };

// core/interceptors/auth.interceptor.ts
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CURRENT_ENV } from '../../config/env-config';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const toastr = inject(ToastrService);

  // Define authentication-related endpoints that should not trigger logout
  const authEndpoints = [
    '/LogInEmployer',
    '/RegisterCompany',
    '/VerifyLoginEmployerOTP',
    '/RefreshToken',
    '/ForgotPassword',
    '/ResetPassword',
    '/hr-link/login/re-verify',
    '/VerifyHRLinkLogin'
  ];

  // Define API endpoints that require authentication
  const protectedEndpoints = [
    '/Employees',
    '/dashboard',
    '/profile',
    '/companies',
    '/pay-day-quick-view',
    '/admin',
    '/company-details',
    '/company-details-view',
    '/payroll-dashboard',
    '/user-management',
    '/existing-users',
    '/new-user-requests',
    '/password-manage',
    '/document-manage',
    '/transactions',
    '/earned-wage-withdrawals',
    '/wage-withdrawal-rollovers',
    '/total-wages',
    '/cixor-payments',
    '/getCIXORPayments',
    '/uploadCixorPaymentPaySlip',
    '/wages-withdrawals-rollovers',
    '/rollover-request',
    '/hr-link/team-member',
    '/hr-link/adding-member',
    '/hr-link/absentee-recorder',
    '/hr-link/leave-calendar-veiw',
    '/hr-link/wage-report',
    '/hr-link/employee-management',
    '/hr-link/hr-admin',
    '/hr-link/onboard-req-approval',
    '/hr-link/onboard-edit-req-approval',
    '/hr-link/absentee-recorder-employees',
    '/hr-link/adding-leave',
    '/hr-link/payroll-management',
    '/hr-link/generate-payroll',
    '/hr-link/bank-transfer-doc',
    '/hr-link/payroll-history',
    '/hr-link/hr-setting',
    '/hr-link/salary-cycle',
    '/hr-link/salary-cycle-create',
    '/hr-link/bulk-uploading',
    '/hr-link/generate-pay-slip',
    '/hr-link/company-calendar',
    '/hr-link/leave-policy',
    '/hr-link/generate-bank-transfer-doc',
    '/hr-link/bank-transfer-doc-hiatory',
    '/hr-link/epf-etf-doc',
    '/hr-link/add-special-allowance',
    '/hr-link/special-allowance-type-requests',
    '/hr-link/special-allowance-requests',
    '/hr-link/add-special-deduction',
    '/hr-link/special-deduction-type-requests',
    '/hr-link/special-deduction-requests'
  ];

  // Check if this is an auth-related endpoint
  const isAuthEndpoint = authEndpoints.some(endpoint =>
    req.url.includes(endpoint)
  );

  // Check if this is a protected endpoint
  const isProtectedEndpoint = protectedEndpoints.some(endpoint =>
    req.url.includes(endpoint)
  );

  // Clone request and add Authorization header if user is logged in and not an auth endpoint
  let clonedReq = req;
  if (!isAuthEndpoint && authService.isLoggedIn()) {
    const token = authService.getToken();
    if (token) {
      clonedReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      });
    }
  }

  return next(clonedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle authentication errors
      if (error.status === 401 && isProtectedEndpoint && !isAuthEndpoint) {
        // Standard 401 handling
        if (authService.isLoggedIn()) {
          // console.log(`401 Unauthorized for: ${req.url}`);
          authService.logout();
          toastr.warning(
            'Your session has expired. Please log in again.',
            'Session Expired',
            { timeOut: 5000 }
          );
          router.navigate(['/login']);
        }
        return throwError(() => error);
      }

      // Handle 404 errors for protected endpoints that might indicate session expiry
      // if (error.status === 404 && isProtectedEndpoint && !isAuthEndpoint) {
      //   // Check if we have authentication token but still getting 404
      //   // This might indicate the server is returning 404 instead of 401 for security
      //   if (authService.isLoggedIn()) {
      //     console.log(`404 for protected endpoint, possible session expiry: ${req.url}`);

      //     // Optional: You might want to verify token validity here
      //     // For now, treat as potential auth issue for protected endpoints
      //     authService.logout();
      //     toastr.warning(
      //       'Resource not found. Your session may have expired. Please log in again.', 
      //       'Session Expired',
      //       { timeOut: 5000 }
      //     );
      //     router.navigate(['/login']);
      //   }
      //   return throwError(() => error);
      // }

      // Handle other HTTP errors
      // switch (error.status) {
      //   case 403:
      //     toastr.error('Access denied. You don\'t have permission to perform this action.', 'Forbidden');
      //     break;
      //   case 404:
      //     // Only show error for non-protected endpoints to avoid noise
      //     if (!isProtectedEndpoint && !isAuthEndpoint) {
      //       toastr.error('The requested resource was not found.', 'Not Found');
      //     }
      //     break;
      //   case 500:
      //     toastr.error('A server error occurred. Please try again later.', 'Server Error');
      //     break;
      //   case 0:
      //     // Network error (no internet connection)
      //     toastr.error('Unable to connect to the server. Please check your internet connection.', 'Network Error');
      //     break;
      //   default:
      //     // For auth endpoints, don't show generic error messages
      //     if (!isAuthEndpoint && !isProtectedEndpoint) {
      //       toastr.error('An unexpected error occurred. Please try again.', 'Error');
      //     }
      //     break;
      // }

      // Clear the cosole after every request -> If the Env is QA or Prod
      if (CURRENT_ENV === 'qa' || CURRENT_ENV === 'prod') {
        console.clear();
      }
      // Re-throw the error so it can be handled by the calling component if needed
      return throwError(() => error);
    })
  );
};